export const MIN_FILTER_NUMBER = 10;
